import { InputGroupAddon as _InputGroupAddon, InputGroupAddonProps as _InputGroupAddonProps } from "reactstrap";

    export const InputGroupAddon = _InputGroupAddon;
    export type InputGroupAddonProps = _InputGroupAddonProps;
    